import React from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { IMainState } from 'store/states'
import InvitationPublication from './components/InvitationPublication'
import EnrolCreatedNotification from './components/EnrolCreatedNotification'
import styles from './EmailNotifications.module.scss'
import ReminderAutomated from './components/ReminderAutomated'

interface Props {
  isNewCourse?: boolean
  disableReminder?: boolean
}

const EmailNotifications: React.FC<Props> = ({
  isNewCourse,
  disableReminder,
}) => {
  const { t } = useTranslation()
  const enrolCreatedEnabled = useSelector(
    ({ general }: IMainState) =>
      general.permissions.courseEnrolCreatedNotificationEnabled
  )

  return (
    <>
      <Form.Group
        className={classNames('border-top mt-3 pt-3', styles.notifications)}
      >
        <div
          className={classNames('blue-darken font-weight-bold', styles.title)}
        >
          {t('administration.courses.new.form.notifications.title')}
        </div>
        <InvitationPublication
          isNewCourse={isNewCourse}
          invitationsDisabled={disableReminder}
        />
        <hr className="my-2" />
        <ReminderAutomated disabled={disableReminder} />
        {enrolCreatedEnabled && (
          <>
            <hr className="my-2" />
            <EnrolCreatedNotification
              isNewCourse={isNewCourse}
              disabled={disableReminder}
            />
          </>
        )}
      </Form.Group>
    </>
  )
}

export default EmailNotifications
